import React from "react";
import GarmentMasonryGrid from "./components/GarmentMasonryGrid";
import FooterCatalogue from "./components/FooterCatalogue";
import CatalogueNavbar from "./components/CatalogueNavbar";
import { Link } from "react-router-dom";
const Garments = () => {
  return (
    <div className="font-Manrope ">
      <CatalogueNavbar />
      <div
        className="h-[28vh] md:h-[50vh] bg-cover bg-center relative"
        style={{ backgroundImage: `url('/GarmentBanner.png')` }}
      >
        {/* Inner div positioned at the bottom left corner */}
        <div className="absolute bottom-[3vh] md:bottom-[10vh] left-[2vh] md:left-[10vh] p-3 text-white text-3xl md:text-4xl ">
          {/* Inner content here */}
          <p>
            Garment{""}
            <span className="ml-2 font-bold text-3xl md:text-4xl">
              Catalogue
            </span>
          </p>
        </div>
      </div>
      {/* masonry grid above start */}
      <div className="w-full  pl-10 pr-10 pt-6 pb-6 md:pl-24 md:pr-24 md:pt-10 md:pb-10">
        {" "}
        <div className="flex flex-row items-center ">
          <img
            src="/Categories.svg" // Replace with your SVG file path
            alt="C"
            className="h-3 w-3 "
          />
          {/* Replace with your icon */}
          <p className="text-sm pl-2">Versatile Collections</p>
        </div>
        <div className="flex flex-wrap">
          {/* First Column (Responsive 50% width) */}
          <div className="w-full md:w-[40%] mt-2 -ml-1 text-4xl">
            Our Versatile<span className="font-bold"> Garment Collections</span>
          </div>

          {/* Second Column (Responsive 50% width with button in top-right) */}
          <div className="hidden md:block w-[60%] p-4  relative">
            <a href="/Catalogue#ContactUs">
              <button className="flex items-center absolute right-0 top-0 rounded overflow-hidden bg-[#465b83] shadow-lg border-2 border-[#465b83]">
                {/* Contact Us Text Section */}
                <div className="bg-white text-[#465b83] px-2 py-1 text-sm rounded">
                  {" "}
                  {/* Reduced padding and smaller text */}
                  Contact Us
                </div>
                {/* Icon Section */}
                <div className="bg-[#465b83] p-1">
                  {" "}
                  {/* Reduced padding */}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 25 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.69531 19.6176C7.39531 19.6176 7.19531 19.5119 6.99531 19.3007C6.59531 18.8783 6.59531 18.2446 6.99531 17.8222L16.9953 7.26117C17.3953 6.83873 17.9953 6.83873 18.3953 7.26117C18.7953 7.68361 18.7953 8.31727 18.3953 8.73971L8.39531 19.3007C8.19531 19.5119 7.99531 19.6176 7.69531 19.6176Z"
                      fill="white"
                    />
                    <path
                      d="M17.6953 18.5615C17.0953 18.5615 16.6953 18.139 16.6953 17.5054V9.05654H8.69531C8.09531 9.05654 7.69531 8.6341 7.69531 8.00044C7.69531 7.36678 8.09531 6.94434 8.69531 6.94434H17.6953C18.2953 6.94434 18.6953 7.36678 18.6953 8.00044V17.5054C18.6953 18.139 18.2953 18.5615 17.6953 18.5615Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </button>
            </a>
          </div>
        </div>
        <div className="mt-5 text-md">
          We are the professional custom garment manufacturer in India and the
          best apparel wholesale supplier for worldwide clothing buyers. We
          provide high-quality clothing products manufacture and wholesale
          service base in India. Please{" "}
          <span className="underline">
            {" "}
            <a href="/Catalogue#ContactUs">
              get in touch with out fabric and garment experts
            </a>
          </span>{" "}
          for any query.
        </div>
      </div>
      {/* masonry gric below end */}
      <div className="px-5 md:px-0">
        <GarmentMasonryGrid />
      </div>

      {/* Footer start */}
      <FooterCatalogue />
      {/* Footer end */}
    </div>
  );
};

export default Garments;
